import AssignClaimContainer from "./AssignClaimContainer";

export default AssignClaimContainer;